import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { camelCase } from 'lodash';

// Components
import Toggle from 'react-toggle';
import { ButtonV2 } from '@zola/zola-ui';
import EditPagesTipsContent from './EditPagesTipsContent';

// Actions
import { showModal } from '../../../../actions/ModalActions';

// Utils
import importImages from '../../../../util/webpack';
import featureFlags from '../../../../util/featureFlags';

const isEditPageHeaderV2 = featureFlags.get('isEditPageHeaderV2');
// Roemove pageImages with isEditPageHeaderV2
const pageImages = importImages(require.context('../../../../assets/images/pages/', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

const pageTips = ({ pageType, pageTipsContent }) => {
  const { title, dek } = pageTipsContent;

  return (
    <section className={`tips__section tips__${pageType.toLowerCase()}`}>
      <h3 className="tips__title">{title}</h3>
      <div className="tips__dek">{dek}</div>
    </section>
  );
};

function EntityHeader({ page, pageIntro, pageInfoBlock, onAdd, entityName, entityOptions, themeKey, onPageToggle, openTipsModal }) {
  const pageType = page && page.type;
  const pageTipsContent = EditPagesTipsContent[pageType] || null;

  return (
    <>
      {isEditPageHeaderV2 ? (
        <section className={`edit-page__header edit-${page.type.toLowerCase()}__header`}>
          <div className="edit-page__title-section">
            <h1 className="edit-page__title">{page.menu_title}</h1>
            {page.type !== 'HOME' && (
              <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Control if guests see this page. Set to &quot;Hidden&quot; if you don't want to use it or it's still a work in progress. Set to &quot;Visible&quot; if you're ready to share.">
                <Toggle
                  checked={!page.hidden}
                  onChange={() => onPageToggle(page.id)}
                  icons={{ checked: <span className="toggle-label checked">Visible</span>, unchecked: <span className="toggle-label unchecked">Hidden</span> }}
                />
              </div>
            )}
            {pageTipsContent && (
              <div className="edit-page__tips" onClick={() => openTipsModal(pageTips({ pageTipsContent, pageType }))}>
                <i className="tips__icon zolaicon-tips" />
                <span className="tips__text">Tips</span>
              </div>
            )}
          </div>
          <div className="edit-page__intro">{pageIntro || page.intro_copy}</div>
          {page && page.type && themeKey && (
            <div className="edit-page__see-demo">
              <a href={`/wedding/sample-${themeKey}/${page.type === 'HOME' ? '' : page.type.toLowerCase()}`} target="_blank" rel="noopener noreferrer">See Sample Page <i className="zolaicon zolaicon-round-arrow-right" /></a>
            </div>
          )}
          {pageInfoBlock && (
            <div className="edit-page__info-block">{ pageInfoBlock }</div>
          )}
          {entityName && (
            <div className="edit-page__add-entity">
              <ButtonV2 onClick={onAdd}>+ Add {entityName}</ButtonV2>
            </div>
          )}
          {entityOptions && (
            <div className="edit-page__entity-options">
              {entityOptions}
            </div>
          )}
        </section>
      ) : (
        <div className={`cms-edit-header row ${page.type.toLowerCase()}-edit-header`}>
          <div className="col-xs-12 col-sm-8">
            <h1 className="page-header-v2 h1">
              {page.menu_title}
              {page.type !== 'HOME' && (
                <div className="pull-right">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Control if guests see this page. Set to &quot;Hidden&quot; if you don't want to use it or it's still a work in progress. Set to &quot;Visible&quot; if you're ready to share.">
                    <Toggle
                      checked={!page.hidden}
                      onChange={() => onPageToggle(page.id)}
                      icons={{ checked: <span className="toggle-label checked">Visible</span>, unchecked: <span className="toggle-label unchecked">Hidden</span> }}
                    />
                  </div>
                </div>
              )}
            </h1>
            <p>{page.intro_copy}</p>
            {page && page.type && themeKey && (
              <a href={`/wedding/sample-${themeKey}/${page.type === 'HOME' ? '' : page.type.toLowerCase()}`} target="_blank" rel="noopener noreferrer" className="margin-top text-button">See demo page &rsaquo;</a>
            )}
            <br />
            {entityName && (
              <ButtonV2 className="margin-top margin-bottom" onClick={onAdd}>+ Add {entityName}</ButtonV2>
            )}
            {entityOptions && entityOptions}
          </div>
          <div className="hidden-xs col-sm-4">
            <img
              src={pageImages(camelCase(page.type))}
              alt={page.menu_title}
              className="margin-top-2x center-block"
              srcSet={`${pageImages(camelCase(page.type))} 1x, ${pageImages(camelCase(`${page.type}@2x`))} 2x`}
              width="110"
              height="110"
            />
          </div>
        </div>
      )}
    </>
  );
}

EntityHeader.propTypes = {
  page: PropTypes.shape({}).isRequired,
  onAdd: PropTypes.func,
  entityName: PropTypes.string,
  entityOptions: PropTypes.element,
  themeKey: PropTypes.string,
  onPageToggle: PropTypes.func,
  pageInfoBlock: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
};

const mapDispatchToProps = dispatch => ({
  openTipsModal: (tips) => {
    dispatch(showModal('TIPS_MODAL', { tipsContent: tips }, { size: 'md' }));
  },
});

export default connect(
  null,
  mapDispatchToProps
)(EntityHeader);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EntityHeader.jsx